import React from 'react';
import "./pages.css";


export default function Disclaimer() {
  return (
    <div>
      	<div className="disclaimer_wrapper mt-4">
				<div className="container">
					<div className="row">
                            <div className="acc_main_head">
                                <h1>
                                    Disclaimer Policy
                                </h1>
                            </div>
                            <div align="justify">
                                <p className='para'>
                                    Information on the site is provided "as is", "as available" basis. Without any representation or warranty and in no event shall MarketsandMarkets be liable in connection with the use of the information made available, unless specifically stated otherwise. You agree that use of this site is at your sole risk. We disclaim all warranties of any kind, including but not limited to any express warranties, statutory warranties, and any implied warranties of: merchantability, fitness for a particular purpose, and non-infringement. Your sole and exclusive remedy relating to your use of the site shall be to discontinue using the site.
                                </p>
                                <div className="row mt-4">
                                    <div className="col-md-4">
                                        <div className="info_block">
                                            <h5 className="acc_sub_head">
                                                Corporate Headquarters
                                            </h5>
                                            <div className="leftLink">
                                                <h3>
                                                    MarketsandMarkets Research Private Ltd. <br/>
                                                    Tower B5, office 101,<br/>
                                                    Magarpatta SEZ,<br/>
                                                    Hadapsar, Pune-411013, India<br/><br/>+1 (206) 401-8844<br/>
                                                    <a href="mailto:salesiq@marketsandmarkets.com" className="link_blue">salesiq@marketsandmarkets.com</a>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                            <div className="info_block">
                                                <h5 className="acc_sub_head">
                                                    USA Address
                                                </h5>
                                                <div className="leftLink">
                                                    <h3>
														MarketsandMarkets Inc.<br/>
                                                        707 Skokie Blvd,<br/>
                                                        Suite 650<br/>
                                                        Northbrook, IL 60062 <br/><br/>
                                                        USA : +1 (206) 401-8844<br/>
                                                        <a href="mailto:salesiq@marketsandmarkets.com" className="link_blue">salesiq@marketsandmarkets.com</a>
                                                    </h3>
                                                </div>
                                            </div>
                                    </div>
									<div className="col-md-4">
                                            <div className="info_block">
                                                <h5 className="acc_sub_head">
                                                    UK Address
                                                </h5>
                                                <div className="leftLink">
                                                    <h3>
													  
													 Regus - Parkshot House, <br/> 5 Kew Road, Richmond, <br/>London, TW9 2PR, <br/>United Kingdom 
                                                        <br/> <br/>UK : +44 20 3869 5400<br/>
                                                        <a href="mailto:salesiq@marketsandmarkets.com" className="link_blue">salesiq@marketsandmarkets.com</a>
                                                    </h3>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                         </div>
				    </div>
			    </div>
			</div>
    </div>
  )
}
